import { Fragment } from 'react';
import { LayoutBuilder } from '~/rage/utils';
import { Layouts } from '~/shared';
import { Background } from './components/Background';
import { GameFruits } from './views/GameFruits';

const LayoutComponent = () => (
	<Fragment>
		<Background />
		<GameFruits />
	</Fragment>
);

const Layout = new LayoutBuilder(LayoutComponent)
	.setDisplayName(Layouts.GameFruits)
	.build();

export default Layout;
